import { StyleProps } from "../styles"

export const button = (props: StyleProps) => ({
  display: `inline-block`,
  margin: props.theme.spacing(0, 2),
})

export const total = (props: StyleProps) => ({
  display: `inline-block`,
  fontSize: props.theme.fontSize.caption,
  margin: props.theme.spacing(0, 2),
})

export const text = (props: StyleProps) => ({
  fontSize: props.theme.fontSize.caption,
})
